import { Plus } from "neetoicons";
import { Button } from "neetoui";
import PropTypes from "prop-types";

import "./menubar.scss";

const AddNew = ({ label = "", onClick, ...otherProps }) => (
  <div className="neeto-molecules-menubar__add-new-wrap" {...otherProps}>
    <Button
      {...{ label, onClick }}
      icon={Plus}
      iconPosition="left"
      iconSize={16}
      size="small"
      style="link"
    />
  </div>
);

AddNew.propTypes = {
  /**
   * To specify the label to be rendered as the add new Button.
   */
  label: PropTypes.string,
};

export default AddNew;
